import { Outlet, Navigate } from 'react-router-dom';
import { useAuthStatus } from '../store/selectors/userSelector';
import { URLS } from '.';

const PublicRoutes = () => {
    const isAuth = useAuthStatus();
    console.log('~~~~~~~~~PUBLIC~~~~~~~~~~~~~~~')
    return (
        isAuth ? <Navigate to={URLS.RIDDELL_HOME} />: <Outlet /> 
    )
}

export default PublicRoutes;